module.exports = __webpack_public_path__ + "static/dev-speed-501ab552a2585d1f2564403638672228.png";